var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("li", [
    _c("strong", { class: { colon: _vm.showColon } }, [
      _c("i", { staticClass: "fa fa-check" }),
      _vm._v(" " + _vm._s(_vm.property.property.names.name) + "\n      "),
    ]),
    _vm._v(" "),
    _c("span", [
      _vm.property.property.valueType === "file"
        ? _c("span", [
            _c(
              "a",
              {
                attrs: {
                  href: _vm._f("fileUploadPath")(_vm.property.property.value),
                  target: "_blank",
                },
              },
              [
                _c("i", {
                  staticClass: "fa fa-external-link",
                  attrs: { "aria-hidden": "true" },
                }),
                _vm._v(
                  "\n                  " +
                    _vm._s(_vm._f("fileName")(_vm.property.property.value)) +
                    "\n              "
                ),
              ]
            ),
          ])
        : _vm.surcharge > 0
        ? _c("span", [
            _vm._v("(+ " + _vm._s(_vm._f("currency")(_vm.surcharge)) + ")"),
          ])
        : _vm.property.property.valueType !== "empty"
        ? _c("span", [_vm._v(_vm._s(_vm.property.property.value))])
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }